<template>
  <div
    class="product__header"
    :itemprop="SCHEMA_ITEM_PROP.NAME"
  >
    <SfHeading
      :title="productTitle"
      :level="1"
      class="sf-heading--no-underline"
    />
  </div>
</template>
<script lang="ts">

import { SCHEMA_ITEM_PROP } from '~~/constants/seo';

export default defineComponent({
  name: 'ProductTitle',

  props: {
    productTitle: {
      type: String,
      required: true,
    },
  },
  setup() {

    return {
      SCHEMA_ITEM_PROP,
    };
  
  },
});

</script>

<style lang="scss" scoped>
.product__header {
  --heading-title-font-weight: var(--font-weight--bold);
  --heading-padding: 0;

  .sf-heading {
    --heading-text-align: var(--heading-horizontal-align);

    &__title {
      font-family: var(--font-family--primary);
    }
  }
}
</style>
